import React, { Component, useDebugValue } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import { ConfirmModal } from '../../../common/components';
import Form from 'antd/lib/form';
import rules from '../../../common/rules/rules';
import Select from 'antd/lib/select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  shiftPaymentActions,
  selectShift,
} from '../ducks';
import {
  currencyFormatter,
} from '../../../common/utils/helpers';

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      shiftPaymentLoan: shiftPaymentActions.request,
    },
    dispatch
  ),
});

const mapStateToProps = (state, props) => ({
  shiftPayment: selectShift(state),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
@Form.create()
export default class PaymentShiftModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    handleModalCancel: PropTypes.func.isRequired,
    activePaymentNumber: PropTypes.number.isRequired,
    maxMonthMovement: PropTypes.number.isRequired,
    loanId: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    showResult: false
  }

  shiftPaymentSubmit = e => {
    e.preventDefault();

    const { actions, form } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        actions.shiftPaymentLoan({
          loanId: this.props.loanId,
          data: values
        });
        this.setState({showResult: true});
      }
    });
  }

  handleCancel = e => {
    this.props.handleModalCancel();
    this.setState({showResult: false});
  }

  render() {
    const { 
      visible, 
      paymentNumbers,
      maxMonthMovement,
      shiftPayment,
      handleModalCancel,
      t 
    } = this.props;
    const { getFieldDecorator } = this.props.form;

    let months = [];
    for (let i = 1; i <= maxMonthMovement; i++) {
      months.push(i);
    }

    if (this.state.showResult && shiftPayment) {
      return (
        <Modal
          title={t('Posun splátok')}
          visible={visible}
          onCancel={this.handleCancel}
          footer={null}
        >
          <div>
            <div>{t("Nová výška mesačnej splátky")}: {currencyFormatter(shiftPayment.result.Amount)} </div>
            <div>{t("Celkový výnos po posune")}: {currencyFormatter(shiftPayment.result.Total)}</div>
          </div>
        </Modal>
      )
    } else {
      return (
        <Modal
          title={t('Posun splátok')}
          visible={visible}
          onCancel={this.handleCancel}
          footer={null}
        >
          <Form onSubmit={this.shiftPaymentSubmit}>
            <Form.Item label={t('Číslo splátky')}>
              {getFieldDecorator('paymentNumber', {
                    rules: rules.required,
                  })(
                    <Select size="default" placeholder={t('Vybrať číslo splátky')}>
                      {paymentNumbers.map((number) => (
                        <Select.Option key={number}>
                          {number}
                        </Select.Option>
                      ))}
                    </Select>
              )}
            </Form.Item>
            <Form.Item label={t('Počet mesiacov')}>
              {getFieldDecorator('monthNumber', {
                  rules: rules.required,
                })(
                  <Select size="default" placeholder={t('Počet mesiacov')}>
                    {months.map((number) => (
                      <Select.Option key={number}>
                        {number}
                      </Select.Option>
                    ))}
                  </Select>
              )}
            </Form.Item>
              <Button type="primary" htmlType="submit">{t('Posunúť splátku')}</Button>
          </Form>
        </Modal>
      );
    }
  }
}




// WEBPACK FOOTER //
// ./src/features/loan-management/components/PaymentShiftModal.js